import IncorrectIcon from '@ingka/ssr-icon/paths/incorrect';
import InformationCircle from '@ingka/ssr-icon/paths/information-circle';
import { ComponentIds } from '@inter-ikea-core/core';
import { useCore } from 'contexts/core';
import { useServiceSettings } from 'contexts/serviceSettings';
import { RootState } from 'ducks';
import { getToggleState as toggleStateSelector } from 'ducks/products';
import { useTranslations } from 'hooks/useTranslations';
import {
  getMaximalFrameHeight,
  shouldDisableSlidingDoorProducts
} from 'rangeConfig/pax/utils/utils';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import SkapaInlineMessage, { InlineMessageVariantEnum } from 'ui/InlineMessage/SkapaInlineMessage';
import media from 'ui/media';
import { adjustMeasurementsSystem } from 'utils/adjustMeasurementsSystem';

const Wrapper = styled.div`
  padding: 0 0 ${({ theme }) => theme.space.md};
  ${media.mobile`
   padding: 1.5rem 1.5rem 0 1.5rem;
  `};
`;

const CeilingHeightInfoMessage = () => {
  const { formatMessage } = useIntl();
  const coreApi = useCore();
  const { getToggleState } = useSelector((state: RootState) => ({
    getToggleState: toggleStateSelector(state)
  }));
  const { unit, useMetric } = useTranslations();
  const { translations } = useServiceSettings();

  const filterState = getToggleState('frames', 'height');

  const frames = coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);
  if (frames.length === 0) {
    return <></>;
  }

  const maxFrameHeight = getMaximalFrameHeight(frames);

  let heightValue: string;
  const localizedHeight = adjustMeasurementsSystem(maxFrameHeight + 40, translations, useMetric);

  const message = 'storageone.lowCeilingHeightInfoMessage';

  if (Number(localizedHeight) === -Infinity) {
    heightValue = (filterState.selected / 10 + 4).toString();
  } else {
    heightValue = localizedHeight;
  }

  const infoMessage = {
    message: message,
    params: { height: heightValue, unit }
  };

  const invalid = shouldDisableSlidingDoorProducts(coreApi);

  return (
    <Wrapper>
      <SkapaInlineMessage
        title={formatMessage({ id: 'storageone.lowCeilingHeightInfoHeading' })}
        body={formatMessage({ id: infoMessage.message }, infoMessage.params)}
        variant={invalid ? InlineMessageVariantEnum.NEGATIVE : InlineMessageVariantEnum.INFORMATIVE}
        subtle={!invalid ? true : false}
        ssrIcon={invalid ? IncorrectIcon : InformationCircle}
      />
    </Wrapper>
  );
};
export default CeilingHeightInfoMessage;
